export default {
  container: {
    width: '100%',
    padding: '0 1rem',
    display: 'flex',
    flex: 1,
    order: 2,
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
  },
  icon: {
    color: '#0d95a1',
    fontSize: '2rem',
    marginRight: '1rem'
  },
  label: {
    whiteSpace: 'nowrap',
    fontSize: `0.82em`,
    marginRight: `1rem`,
  },
  inputWrapper: {
    width: `100%`,
    padding: 0,
  },
  input: {
    display: 'block',
    width: '100%',
    padding: '.5rem 1rem',
    border: 'none',
    outline: 'none',
    fontSize: '1rem',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
  },
};
